import { NavigationItem } from "./environment.types"

export function transformRoutes (routes: NavigationItem[]): any {
  return routes.map(({ link = {}, title, items = []}) => {
    return {
      link: {
        value: {
          ...link,
          text: (title && title.value) || link.text,
          href: link.href || link.url
        }
      },
      items: items && items.length > 0 ? transformRoutes(items) : []
    }
  })
}
